import "./App.css"
import "bootstrap/dist/css/bootstrap.min.css"
import "flatpickr/dist/flatpickr.min.css"

import RootLayout from "./RootLayout"
import { RouterProvider } from "react-router"
import Home from "./views/Home/Home"
import SignUp from "./views/Auth/SignUp"
import Login from "./views/Auth/Login"
import Dashboard from "./views/Dashboard/Dashboard"
import { createBrowserRouter } from "react-router-dom"
import { Toaster } from "react-hot-toast"
import { useEffect } from "react"
import AuthProvider from "./context/AuthProvider"
import UserList from "./views/UserList/UserList"
import AddUser from "./views/UserList/AddUser"
import StrList from "./views/StrList/StrList"
import AddStr from "./views/StrList/AddStr"
import ContactUs from "./views/Other/ContactUs"
import About from "./views/Other/About"
import { managerAccessloader, userAccessloader, userloader } from "./utils"
import Error from "./views/Error/Error"
import ViewUser from "./views/UserList/ViewUser/ViewUser"
import MobileUsersProvider from "./context/MobileUsersProvider"
import UnloggedUserList from "./views/UserList/UnloggedUserList"
import TradeLog from "./views/StrList/TradeLog"
import TradeAnalysis from "./views/StrList/TradeAnalysis"
import StretagyProvider from "./context/StretagyProvider"
function App() {
   const router = createBrowserRouter([
      {
         path: "/",
         element: <RootLayout />,
         children: [
            { path: "/", element: <Home /> },
            { path: "/home", element: <Home /> },
            { path: "/signup", element: <SignUp /> },
            { path: "/login", element: <Login /> },
            { path: "/contact", element: <ContactUs /> },
            { path: "/about", element: <About /> },
            { path: "/dashboard", element: <Dashboard /> },
            { path: "/users", element: <UserList />, loader: userloader },
            { path: "/unlogged-user", element: <UnloggedUserList />, loader: managerAccessloader },
            { path: "/users/add", element: <AddUser />, loader: userloader },
            { path: "/users/edit/:id", element: <AddUser />, loader: userAccessloader },
            { path: "/users/view/:id", element: <ViewUser />, loader: userAccessloader },
            // { path: "/stocks", element: <StockList />, loader: userloader },
            // { path: "/stocks/add", element: <AddStock />, loader: userloader },
            // { path: "/stocks/edit/:id", element: <AddStock />, loader: userloader },
            { path: "/tradelog", element: <TradeLog />, loader: userloader },
            { path: "/tradelog/:id", element: <TradeAnalysis />, loader: userloader },
            { path: "/str", element: <StrList />, loader: userloader },
            { path: "/str/add", element: <AddStr />, loader: userloader },
            { path: "/str/edit/:id", element: <AddStr />, loader: userloader },

            { path: "/*", element: <Error /> }
         ]
      }
   ])
   useEffect(() => {
      // localStorage.clear()
      // return () => {}
   }, [])
   return (
      <div className="App">
         <AuthProvider>
            <StretagyProvider>
               <MobileUsersProvider>
                  <RouterProvider router={router}></RouterProvider>
                  <Toaster />
               </MobileUsersProvider>
            </StretagyProvider>
         </AuthProvider>

         {/* <RootLayout></RootLayout> */}
      </div>
   )
}

export default App
